import { useEffect } from 'react';

const CookiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#05070A] text-white">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-8">
          <a href="/" className="text-blue-400 hover:text-blue-300 transition-colors inline-flex items-center gap-2">
            ← Back to V&V
          </a>
        </div>
        
        <div className="prose prose-invert max-w-none">
          <h1 className="text-4xl font-bold mb-4">Cookie Policy</h1>
          <div className="flex gap-6 text-gray-400 text-sm mb-8 pb-4 border-b border-gray-800">
            <span>Effective: 1 January 2026</span>
            <span>Last updated: 1 January 2026</span>
          </div>
          
          <div className="bg-blue-500/10 border-l-4 border-blue-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-300">
              This Cookie Policy explains what cookies are, which cookies Vett & Venture uses on vettandventure.com, and how you can manage your cookie preferences. It should be read alongside our <a href="/app/privacy" className="text-blue-400 hover:underline">Privacy Policy</a>.
            </p>
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. What Are Cookies?</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work efficiently and provide information to the website operator.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Categories of Cookies We Use</h2>
          
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 mb-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-lg font-semibold">Strictly Necessary Cookies</h3>
              <span className="text-xs px-3 py-1 rounded-full bg-blue-500/20 text-blue-400 border border-blue-500/30">Always Active</span>
            </div>
            <p className="text-gray-300">Essential for the website and platform to function. Enable core features such as authentication, session management, and security.</p>
          </div>
          
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 mb-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-lg font-semibold">Functional Cookies</h3>
              <span className="text-xs px-3 py-1 rounded-full bg-yellow-500/20 text-yellow-400 border border-yellow-500/30">Optional</span>
            </div>
            <p className="text-gray-300">Allow the website to remember choices you make (such as language preference or dark mode) and provide enhanced features.</p>
          </div>
          
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 mb-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-lg font-semibold">Analytics Cookies</h3>
              <span className="text-xs px-3 py-1 rounded-full bg-yellow-500/20 text-yellow-400 border border-yellow-500/30">Optional</span>
            </div>
            <p className="text-gray-300">Help us understand how visitors interact with our website — which pages are visited, how long visitors spend, and where they arrive from.</p>
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Managing Cookies</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            When you first visit our website, you will see a cookie banner allowing you to accept or decline optional cookies. You can change your preferences at any time using the Cookie Settings link in the footer.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            You can also manage cookies directly through your browser settings. Most browsers allow you to refuse new cookies, delete existing cookies, and set preferences for specific websites.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Contact</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            If you have any questions about our use of cookies, please contact us at <a href="mailto:privacy@vettandventure.com" className="text-blue-400 hover:underline">privacy@vettandventure.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;